import React from 'react';
import Menu from '@material-ui/core/Menu';
import { translate } from 'components/Translation';
import SettingsMenuItem from './SettingsMenuItem';
import CustomButton from 'components/CustomButtons/Button';
import { makeStyles } from '@material-ui/core/styles';
import { iconHoverFilter, menuBoxShadowColor, menuHoverBgColor } from 'assets/jss/material-dashboard-pro-react';
import classNames from 'classnames';
import { setDataLayer } from 'commons/gtm/dataLayerWrapper';
import { getLanguage } from 'utils/language/language';
import { upIdSelector } from 'redux/modules/session/selectors';
import { useSelector } from 'react-redux';

const styles = () => ({
	menu: ({ width }: any) => ({
		width: width,
		padding: '0rem 0.5rem',
		boxShadow: `0 4px 8px ${menuBoxShadowColor}`,
		borderRadius: '1rem',
	}),
	activeMenu: {
		backgroundColor: menuHoverBgColor,
		borderRadius: '1rem',
		'& img': {
			filter: iconHoverFilter,
		},
	},
});

const useStyles = makeStyles(styles);

export default function Settings() {
	const classes = useStyles({ width: 250 });
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const accId = useSelector(upIdSelector);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
		setDataLayer('secondary_navigation', getLanguage(), null, accId, null, {
			link_name: 'Settings',
		});
	};

	const handleClose = (name: string) => {
		setDataLayer('secondary_navigation', getLanguage(), null, accId, null, {
			link_name: `Settings:${name}`,
		});
		setAnchorEl(null);
	};

	const isMenuOpen = Boolean(anchorEl);

	const accountButtonClasses = classNames({
		[classes.activeMenu]: isMenuOpen,
	});

	const btnAriaLabel = translate('path.settings');
	const menuId = `${btnAriaLabel.split(' ').join('')}-menu`;
	return (
		<>
			<CustomButton
				color="primary-dark-v2"
				noMargin
				aria-label={btnAriaLabel}
				onClick={handleClick}
				className={accountButtonClasses}
				aria-haspopup="true"
				aria-expanded={isMenuOpen}
				aria-controls={menuId}
			>
				<img src="/settings.svg" height={24} width={24} alt="" role="presentation" />
			</CustomButton>
			<Menu
				id={menuId}
				elevation={0}
				getContentAnchorEl={null}
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center',
				}}
				PaperProps={{
					className: classes.menu,
				}}
				disableAutoFocus
			>
				<SettingsMenuItem
					onClick={() => handleClose(translate('path.my.users'))}
					route="/dashboard/users"
					label={translate('path.my.users')}
				></SettingsMenuItem>
				<SettingsMenuItem
					onClick={() => handleClose(translate('path.my.organizations'))}
					route="/dashboard/organizations"
					label={translate('path.my.organizations')}
				></SettingsMenuItem>
			</Menu>
		</>
	);
}
